export const PLANS = [
  {
    id: 1,
    title: "Basic RSA Plan",
    originalPrice: 999,
    discountedPrice: 499,
    provider: "Provider A"
  }
];


export const IncidentType = [
  { label: 'Accident', value: 'Accident' },
  { label: 'Breakdown', value: 'Breakdown' },
  { label: 'Clutch Issue', value: 'Clutch Issue' },
  { label: 'Out of fuel', value: 'Out of fuel' },
  { label: 'Flat Tyre', value: 'Flat Tyre'},
  { label: 'Starting Issue', value: 'Starting Issue'},
  { label: 'Accelerator Issue', value: 'Accelerator Issue'},
  { label: 'Others', value: 'Others'}
  
];

export const PDF_URL = 'https://rsa.gaadibazaar.net/assets/pdf/RSA_Terms_Conditions.pdf';
export const GB_URL = 'https://gaadibazaar.net/';